import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { useTheme }, "@mui/material/Box": Box, "@mui/material/Card": Card, "@mui/material/CardContent": CardContent, "@mui/material/CardMedia": CardMedia, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/icons-material/SkipPrevious": SkipPreviousIcon, "@mui/icons-material/PlayArrow": PlayArrowIcon, "@mui/icons-material/SkipNext": SkipNextIcon } } });
export default ClientProvider;
